import gql from 'graphql-tag';

const UPDATE_RECORD_VIEW_DOWNLOAD = gql`mutation updateRecordViewDownload ($input: UpdateRecordInput) {
    updateRecordViewDownload (input: $input) {
        status,
        message,
        data
    }
}`;

export default UPDATE_RECORD_VIEW_DOWNLOAD;
